import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { load } from 'recaptcha-v3';
import { getBackendHost } from '@segment/tracking/scripts';
export var fetchUserExists = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signal, email) {
    var errorMessage, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errorMessage = "Error trying to fech user email";
            _context.prev = 1;
            _context.next = 4;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/signup/currentUserCheck"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return {
                error: errorMessage
              };
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.log(_context.t0);

          case 11:
            return _context.abrupt("return", {
              error: errorMessage
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function fetchUserExists(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Send form data to gateway api and perform signup for user.
 * @param email user email
 * @returns success or error message from server
 */
export var fetchSignup = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signal, formData) {
    var env, topLevel, errorMessage, recaptchaClientKey, recaptcha, recaptchaToken, response, redirectUrl, message;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            env = process.env.ENVIRONMENT;
            topLevel = env && env !== "staging" ? "com" : "build";
            errorMessage = "Error trying to signup";
            _context2.prev = 3;
            // Get recaptcha token for posting to `segment-site-backend`.
            // See https://developers.google.com/recaptcha/docs/v3 for more info.
            recaptchaClientKey = process.env.RECAPTCHA_GCP_CLIENT_KEY || "";
            _context2.next = 7;
            return load(recaptchaClientKey);

          case 7:
            recaptcha = _context2.sent;
            _context2.next = 10;
            return recaptcha.execute("form");

          case 10:
            recaptchaToken = _context2.sent;
            _context2.next = 13;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/signup/"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(_objectSpread(_objectSpread({}, formData), {}, {
                recaptchaToken: recaptchaToken
              })),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return {
                success: false,
                message: errorMessage
              };
            });

          case 13:
            response = _context2.sent;
            redirectUrl = response.success && "https://app.segment.".concat(topLevel, "/signup?response=").concat(response.message) || undefined;
            message = !response.success && response.message || undefined;
            return _context2.abrupt("return", {
              success: response.success,
              message: message,
              redirectUrl: redirectUrl
            });

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](3);
            console.log(_context2.t0);

          case 22:
            return _context2.abrupt("return", {
              success: false,
              message: errorMessage
            });

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 19]]);
  }));

  return function fetchSignup(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Password strength call.
 * Send the password to backend and return the score from it.
 * @param string password
 * @returns {PasswordStrengthResponse}
 */
export var checkPassword = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(signal, password) {
    var pwdStrength;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/signup/password/strength"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                password: password
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            });

          case 3:
            pwdStrength = _context3.sent;
            return _context3.abrupt("return", pwdStrength);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw Error("Something happened when trying to fetch password strength");

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function checkPassword(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();